import React from "react";
import "./ProductInventoryDetailComponent.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { getAllSalePoint } from "../../../services/utilsSalePoint";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";

import {
  getProductInfo,
  getProductInventoryDetail,
} from "../../../services/utilsProductInventory";
import OperationsProductInvetoryDetail from "./OperationsProductInvetoryDetail";
import ResumeProductInvetoryDetail from "./ResumeProductInventoryDetail";
// import { red100 } from "material-ui/styles/colors";
import { CircularProgress } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ProductInventoryDetailComponent = (props) => {
  const {
    fk_organization,
    fk_product,
    updateSelectedSalePoint, // No need to destructure from a second parameter
  } = props;
  const [salePoints] = useState(props.salePoints);
  const [selectedSalePoint, setSelectedSalePoint] = useState(
    props.selectedSalePoint
  );
  const [product, setProduct] = useState(null);
  const [loadingSalePoints, setLoadingSalePoints] = useState(true);
  const [productInventoryLoading, setProductInventoryLoading] = useState(false);
  const [productInventoryInfo, setProductInventoryInfo] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChangeSalePoint = async (event) => {
    for (let i = 0; i < salePoints.length; i++) {
      if (salePoints[i].id === parseInt(event.target.value)) {
        setSelectedSalePoint(salePoints[i]);
        updateSelectedSalePoint(salePoints[i]);
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const fetchData = () => {
    getProductInfo(fk_product)
      .then((data) => {
        setProduct(data);
        setLoadingSalePoints(false);
      })
      .then(fetchProductInventoryInfo);
  };

  const fetchProductInventoryInfo = () => {
    setProductInventoryLoading(true);
    getProductInventoryDetail(fk_product, selectedSalePoint.id).then((data) => {
      setProductInventoryInfo(data);
    });
    setProductInventoryLoading(false);
  };

  useEffect(() => {
    setLoadingSalePoints(true);
    fetchData();
  }, []);

  useEffect(() => {
    fetchProductInventoryInfo();
  }, [selectedSalePoint]);

  return (
    <>
      <div className="main-product-inventory-detail">
        {loadingSalePoints ? (
          <CircularProgress></CircularProgress>
        ) : (
          <>
            <div className="product-inventory-header">
              <div className="p-i-rowComponent">
              <Link to="/inventarios">
                <ArrowBackIcon sx={{ color: '#01A532' }}></ArrowBackIcon>
              </Link>
              </div>
              <div className="p-i-product-name">
                <h6>{product.name}</h6>
              </div>
            </div>
            <div className="product-inventory-image">
              <img src={product.image_url} alt="Imagen del producto" />
            </div>
            <div className="product-inventory-sale-points">
              <div className="product-inventory-sale-points-content">
                Puntos de Venta
                <Select
                  variant="standard"
                  value={selectedSalePoint.id}
                  onChange={handleChangeSalePoint}
                  className="sale-point-form-select"
                >
                  {salePoints.map((salePoint, index) => (
                    <MenuItem key={index} value={salePoint.id}>
                      {salePoint.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            {productInventoryInfo && !productInventoryLoading && (
              <div className="product-inventory-bar-options">
                <Tabs 
                  value={selectedTab} 
                  onChange={handleTabChange}
                  className="tabs-p-i"
                  indicatorColor="primary"
                  textColor="primary"
                  sx={{
                    "& .MuiTab-root": {
                      color: "#01A532",
                      fontSize: "14px",
                      "&.Mui-selected": {
                        color: "#01A532",
                      },
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#01A532",
                    },
                  }}
                >
                  <Tab label="Resumen" {...a11yProps(0)} />
                  <Tab label="Operaciones" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={selectedTab} index={0}>
                  <div className="tab-panel-content">
                    <ResumeProductInvetoryDetail
                      productInfo={productInventoryInfo}
                      product={product}
                    ></ResumeProductInvetoryDetail>
                  </div>
                </TabPanel>
                <TabPanel value={selectedTab} index={1} className="tab-panels">
                  <div className="tab-panel-content">
                    <OperationsProductInvetoryDetail
                      productInfo={productInventoryInfo}
                      product={product}
                      salePoints={salePoints}
                      selectedSalePoint={selectedSalePoint}
                    ></OperationsProductInvetoryDetail>
                  </div>
                </TabPanel>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ProductInventoryDetailComponent;
